import { render, staticRenderFns } from "./OrganizationMentorsCard.vue?vue&type=template&id=08df8ef7&scoped=true&"
import script from "./OrganizationMentorsCard.vue?vue&type=script&lang=js&"
export * from "./OrganizationMentorsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08df8ef7",
  null
  
)

export default component.exports